import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/design-system/casing")({
  component: () => <Navigate to="/admin/design-system/casing" />,
});
